import { makeStyles, tokens } from "@fluentui/react-components";

export const useYellowpadPlaybookCardStyles = makeStyles({
  card: {
    padding: "1.5rem",
    backgroundColor: tokens.colorNeutralBackground2Selected,
    gap: 0,
  },
  name: {
    fontWeight: "bold",
  },
  updatedAt: {
    marginLeft: "1.5rem",
  },
});
